import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NAV_LINKS } from '@/data/site';
import Button from '@/components/base/Button';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 bg-[#090909] ${
        scrolled || menuOpen ? 'border-b border-white/10' : 'border-b border-white/5'
      }`}
    >
      <div className="w-full flex items-center justify-between gap-4 px-4 md:px-8 lg:px-12 h-20 md:h-24">
        <Link to="/" className="flex items-center shrink-0" aria-label="KOR38 home">
          <img
            src="https://storage.helloreaddy.io/project_files/70bd3036-f013-4766-9098-d293cc2afad4/1561658e-8104-4b44-843d-3c206e044c64_compressed_KOR38-Dark-Background-1200-x-400-No-words.webp"
            alt="KOR38"
            className="h-11 md:h-14 w-auto object-contain"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-6 lg:gap-8" aria-label="Primary">
          {NAV_LINKS.map((link) => {
            const active =
              link.path === '/' ? location.pathname === '/' : location.pathname.startsWith(link.path);
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`font-label text-[13px] uppercase tracking-[0.16em] transition-colors duration-300 whitespace-nowrap ${
                  active ? 'text-primary-400' : 'text-foreground-700 hover:text-primary-300'
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-3">
          <Button to="/services" variant="primary" size="md" className="hidden md:inline-flex">
            Find Your Connection
          </Button>

          <button
            type="button"
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
            aria-controls="mobile-menu"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-11 h-11 flex items-center justify-center rounded-md border border-background-300 text-foreground-900 cursor-pointer"
          >
            <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div
          id="mobile-menu"
          className="md:hidden bg-[#090909] border-t border-white/10 max-h-[calc(100vh-5rem)] overflow-y-auto"
        >
          <nav className="flex flex-col px-4 py-4" aria-label="Mobile">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="font-label text-[15px] uppercase tracking-[0.14em] text-foreground-800 hover:text-primary-300 py-4 border-b border-white/10"
              >
                {link.label}
              </Link>
            ))}
            <Button to="/services" variant="primary" size="lg" className="mt-5 w-full">
              Find Your Connection
            </Button>
          </nav>
        </div>
      ) : null}
    </header>
  );
}